import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CmsService} from '../cms.service';
import {ExcelExportService} from '../excel.export.service';
import {Constants} from '../../../shared/utils/constants';
import {Subscription} from 'rxjs';
import {NumNotRoundPipe} from 'src/app/shared/pipes/common.pipe';
import * as moment from 'moment';

declare var $: any;

interface ExportParams {
  order_by: string;
  kyc_status: string;
  order_type: string;
  q: string;
}

@Component({
  selector: 'fx-export-excel',
  templateUrl: './export-excel.component.html',
  styleUrls: ['./export-excel.component.sass']
})
export class ExportExcelComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() totalRecord;
  @Input() pageSize;
  @Input() currency;
  @Input() params: ExportParams;
  autoExport: any = {
    enable: false,
    holding: false,
    filter: false,
    totalStep: 0,
    step: 0,
    progress: 0
  };
  listDataExport = [];
  countries = [];
  subscriptions: any = {
    getExport: new Subscription(),
    export: new Subscription(),
  };
  fixedNumber = Constants.FIXED_NUMBER
  constructor(
    private service: CmsService,
    private exportService: ExcelExportService,
    private decimal: NumNotRoundPipe,
  ) {
    this.countries = Constants.COUNTRIES.map((c) => {
      return { label: c.name, value: c.code };
    });
  }

  ngOnInit(): void {
  }

  getCountryNameByCode(code): string {
    return this.countries.find(v => v.value === code)?.label || '';
  }

  getDataExport(pageIndex): void {
    this.subscriptions.getExport = this.service
      .getCustomers({
        q: this.params.q || '',
        page: pageIndex,
        page_size: this.pageSize,
        order_type: this.params.order_type || 'asc',
        order_by: this.params.order_by || 'user_id',
        kyc_status: this.params.kyc_status || ''
      })
      .subscribe((data) => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          // use for auto export
          let newExportData = [];
          if (this.autoExport.enable) {
            this.autoExport.progress = (this.autoExport.totalStep < 1)
              ? 100
              : (this.autoExport.step / this.autoExport.totalStep) * 100;
            if (this.autoExport.filter) {
              newExportData = data.data.filter(f => !Constants.IGNORE_COUNTRY_EXPORT.includes(f.country));
            } else {
              newExportData = data.data;
            }
            this.handleGetExportData(newExportData);
          }
        }
      });
  }

  onAutoExport(isFilter): void {
    this.autoExport.enable = true;
    this.listDataExport = [];
    if (isFilter) {
      // export data with filter ignore country
      this.autoExport.filter = true;
    } else {
      this.autoExport.filter = false;
    }
    this.autoExport.totalStep = this.totalRecord / this.pageSize;
    this.autoExport.step = 1;
    this.getDataExport(1);
  }
  handleGetExportData(exports): void {
    if (exports.length > 0) {
      this.subscriptions.export = setTimeout(() => {
        this.listDataExport = [...this.listDataExport, ...exports];
        if (this.autoExport.step < this.autoExport.totalStep) {
          this.autoExport.step += 1;
          this.getDataExport(this.autoExport.step);
        } else {
          this.exportToExcel(this.listDataExport);
          this.resetAutoExport();
        }
      }, 200);
    }
  }

  formatNumber(val): number{
    val = val.replaceAll(',','')
    return Number(val)
  }

  exportToExcel(exports): void {
    const customers = [];
    exports.forEach(value => {
      let fixedNumber = value.currency?this.fixedNumber[value.currency]:this.fixedNumber['jpy']
      let profit =  this.getProfitNetBalance(value.totalBalance, value.totalPNL)
      customers.push({
        'MT5 ID': value.mt5Account,
        'IB ID': value.ibId,
        'MT5 account opening date': moment(value.mt5CreateTime).format('YYYY/MM/DD'),
        Activation: value.getActivation(),
        Username: value.getUsername(),
        'Username(JP)': value.getUsernameJP(),
        Email: value.email,
        KYC: value.getTextKYC(),
        Country: this.getCountryNameByCode(value.country),
        'Total Volume':  this.formatNumber(this.decimal.transform(value.totalVolume, '1.2-2')),
        'Total Order': value.totalOrder,
        'Currency':value.currency?value.currency.toUpperCase():'',
        'Total Balance':  this.formatNumber(this.decimal.transform(value.totalBalance, fixedNumber)),
        'Total PnL':  this.formatNumber(this.decimal.transform(value.totalPNL, fixedNumber)),
        'Realized PnL':  this.formatNumber(this.decimal.transform(value.realizedPnl, fixedNumber)),
        'Total Deposit':  this.formatNumber(this.decimal.transform(value.deposit, fixedNumber)),
        'Total Withdraw':  this.formatNumber(this.decimal.transform(value.withdraw, fixedNumber)),
        'Net Asset':  this.formatNumber(this.decimal.transform(value.netAsset, fixedNumber)),
        'PROFIT/NET BALANCE RATIO': this.formatNumber(this.decimal.transform(profit,'1.2-2')),
        'BONUS':  this.formatNumber(this.decimal.transform(value.bonus, fixedNumber)),
        });
      });
      
    const fileName = 'customer_list_' + moment(new Date()).format('HH_mm_DD_MM_yyyy');

    this.exportService.exportExcel(customers, fileName);
  }

  getProfitNetBalance(totalBalance, totalPNL): number {
    if (totalBalance !==  0 && totalPNL !== 0) {
      return (totalPNL / totalBalance) ;
    }
    return 0;
  }

  resetAutoExport(): void {
    this.autoExport = {
      enable: false,
      holding: false,
      filter: false,
      totalStep: 0,
      step: 0,
      progress: 0
    };
    this.listDataExport = [];
    setTimeout(() => {
      $('#modalLoadingExport .close').trigger('click');
    }, 200);
  }
  private formatCurrency(curren, value): string {
    switch (curren){
      case 'usd': {
        return value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }
      default: {
        return value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }
    }
  }
  ngAfterViewInit(): void {
    $('#modalLoadingExport').on('hide.bs.modal', () => {
      this.resetAutoExport();
    });
  }
  ngOnDestroy(): void {
    for (const key in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(key) && this.subscriptions[key]) {
        this.subscriptions[key].unsubscribe();
      }
    }
  }

}
